import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LogExecucaoColetaService } from 'src/services/log-execucao-coleta.service';
import { EstacaoService } from 'src/services/estacao.service';
import { ColetaService } from 'src/services/coleta.service';
import { PermissoesService } from 'src/services/permissoes.service';
import * as moment from 'moment';

@Component({
    selector: 'app-log-execucao-coleta',
    templateUrl: './log-execucao-coleta.component.html',
    styleUrls: ['./log-execucao-coleta.component.scss'],
    standalone: false
})
export class LogExecucaoColetaComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  loading: boolean = false;
  
  // Filtros
  estacaoSelecionada: number | null = null;
  configuracaoColetaSelecionada: number | null = null;
  statusCodeSelecionado: string | null = null;
  dataInicio: Date | null = null;
  dataFim: Date | null = null;
  
  // Dropdowns
  dropDownEstacoes: any[] = [];
  dropDownConfiguracoesColeta: any[] = [];
  dropDownStatusCodes: any[] = [
    { label: '200 - Sucesso', value: '200' },
    { label: '400 - Bad Request', value: '400' },
    { label: '404 - Not Found', value: '404' },
    { label: '500 - Internal Server Error', value: '500' }
  ];
  
  // Flag para controlar se já foi filtrado
  dadosFiltrados: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  constructor(
    private logExecucaoColetaService: LogExecucaoColetaService,
    private estacaoService: EstacaoService,
    private coletaService: ColetaService,
    private messageService: MessageService,
    protected permissaoService: PermissoesService,
  ) {}

  ngOnInit(): void {
    this.carregarEstacoes();
    this.carregarConfiguracoesColeta();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  carregarEstacoes(): void {
    this.estacaoService.lookup().subscribe({
      next: (res) => {
        const estacoes = res || [];
        this.dropDownEstacoes = estacoes.map((item: any) => ({
          label: item.descricao || `Estação ${item.id}`,
          value: item.id
        }));
      },
      error: (err) => {
        console.error('Erro ao carregar estações:', err);
      }
    });
  }

  carregarConfiguracoesColeta(): void {
    this.coletaService.index().subscribe({
      next: (res) => {
        const configuracoes = res.data || res || [];
        this.dropDownConfiguracoesColeta = configuracoes.map((item: any) => ({
          label: item.descricao || `Coletor ${item.id}`,
          value: item.id
        }));
      },
      error: (err) => {
        console.error('Erro ao carregar configurações de coleta:', err);
      }
    });
  }

  filtrar(): void {
    this.loading = true;
    
    const filtros: any = {};

    if (this.estacaoSelecionada) {
      filtros.estacao_id = this.estacaoSelecionada;
    }
    if (this.configuracaoColetaSelecionada) {
      filtros.configuracao_coleta_id = this.configuracaoColetaSelecionada;
    }
    if (this.statusCodeSelecionado) {
      filtros.status_code = this.statusCodeSelecionado;
    }
    if (this.dataInicio) {
      filtros.data_inicio = moment(this.dataInicio).format('YYYY-MM-DD');
    }
    if (this.dataFim) {
      filtros.data_fim = moment(this.dataFim).format('YYYY-MM-DD');
    }

    this.logExecucaoColetaService.listar(filtros).subscribe({
      next: (res) => {
        this.data = Array.isArray(res) ? res : [];
        this.loading = false;
        this.dadosFiltrados = true;
        setTimeout(() => {
          this.calculateScrollHeight();
        }, 200);
        
        if (this.data.length === 0) {
          this.messageService.add({ 
            severity: 'info', 
            summary: 'Informação', 
            detail: 'Nenhum registro encontrado para os filtros selecionados' 
          });
        }
      },
      error: (err) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Erro', 
          detail: 'Erro ao carregar logs' 
        });
        this.loading = false;
        this.dadosFiltrados = true;
      }
    });
  }

  formatarDataHora(dataHora: string): string {
    if (!dataHora) return 'N/A';
    return moment(dataHora).format('DD/MM/YYYY HH:mm:ss');
  }

  getStatusSeverity(statusCode: string): string {
    if (!statusCode) return '';
    const code = parseInt(statusCode);
    if (code >= 200 && code < 300) return 'success';
    if (code >= 400 && code < 500) return 'warn';
    if (code >= 500) return 'danger';
    return '';
  }

  isStatusWarning(statusCode: string): boolean {
    if (!statusCode) return false;
    const code = parseInt(statusCode);
    return code >= 400 && code < 500;
  }

  isStatusError(statusCode: string): boolean {
    if (!statusCode) return false;
    const code = parseInt(statusCode);
    return code >= 500;
  }

  getNomeEstacao(item: any): string {
    if (item.estacao && typeof item.estacao === 'object') {
      return item.estacao.descricao || `Estação ${item.estacao_id}`;
    }
    return item.estacao_id ? `Estação ${item.estacao_id}` : 'N/A';
  }

  getNomeConfiguracao(item: any): string {
    if (item.configuracao_coleta && typeof item.configuracao_coleta === 'object') {
      return item.configuracao_coleta.descricao || `Coletor ${item.configuracao_coleta_id}`;
    }
    return item.configuracao_coleta_id ? `Coletor ${item.configuracao_coleta_id}` : 'N/A';
  }

}

